import Axios from "axios";
import Swal from "sweetalert2";
import { useEffect } from "react";
import { getCurrentYearMonth } from "./DateUtils";

// Centralized API headers to avoid repetition
const API_HEADERS = { headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" } };

// ดึงข้อมูลจาก Table ใดๆ ก็ได้
export async function getData(table, where) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-data`,
      {
        table: table,
        where: where,
      },
      API_HEADERS
    );
    if (Array.isArray(response.data)) {
      return response.data;
    }
    if (response.data && response.data.status === "OK" && Array.isArray(response.data.data)) {
      return response.data.data;
    }
    if (response.data && response.data.status === "FAILED") {
      console.error("getData failed:", response.data.message);
      return [];
    }
    return response.data?.data || [];
  } catch (error) {
    console.error("Error fetching data:", error);
    // Return empty array for list-style endpoints to avoid null reference checks
    return [];
  }
}

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ แต่ต้องเป็น Comp_Id ตามล็อกอิน
export async function getDataWithComp(table, order, options = {}) {
  try {
    const payload = {
      table: table,
      order: order,
      comp_id: window.localStorage.getItem("company"),
    };
    if (options?.fields) {
      payload.fields = options.fields;
    }
    if (options?.limit !== undefined) {
      payload.limit = options.limit;
    }
    if (options?.offset !== undefined) {
      payload.offset = options.offset;
    }
    if (options?.includeTotal !== undefined) {
      payload.include_total = options.includeTotal;
    }
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-data-with-comp`,
      payload,
      API_HEADERS
    );
    // รองรับทั้ง format เก่า (array) และ format ใหม่ ({ status: "OK", data: [...] })
    if (Array.isArray(response.data)) {
      return response.data; // format เก่า
    } else if (response.data && response.data.status === "OK" && Array.isArray(response.data.data)) {
      return response.data.data; // format ใหม่
    } else if (response.data && response.data.status === "FAILED") {
      console.error("Error fetching data with comp:", response.data.message);
      return [];
    }
    return response.data?.data || [];
  } catch (error) {
    console.error("Error fetching data with comp:", error);
    return [];
  }
}

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ และสามารถ JOIN Table ได้ด้วย
export async function getDataWithJoin(select, table, join, order) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-data-with-join`,
      {
        select: select,
        table: table,
        join: join,
        order: order,
      },
      API_HEADERS
    );
    // รองรับทั้ง format เก่า (array) และ format ใหม่ ({ status: "OK", data: [...] })
    if (Array.isArray(response.data)) {
      return response.data; // format เก่า
    } else if (response.data && response.data.status === "OK" && Array.isArray(response.data.data)) {
      return response.data.data; // format ใหม่
    } else if (response.data && response.data.status === "FAILED") {
      console.error("Error fetching data with join:", response.data.message);
      return [];
    }
    return response.data?.data || [];
  } catch (error) {
    console.error("Error fetching data with join:", error);
    return [];
  }
}

// ดึงข้อมูลจาก Database (สำหรับรายงาน)
export async function getDataByQuery(query) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get`,
      {
        query: query,
      },
      API_HEADERS
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data by query:", error);
    return [];
  }
}

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ โดยใช้ DocId
export async function getByDocId(table, docId, andOrder) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-by-doc-id`,
      {
        table: table,
        doc_id: docId,
        and_order: andOrder,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ โดยใช้ RecId
export async function getByRecId(table, recId, andOrder) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-by-rec-id`,
      {
        table: table,
        rec_id: recId,
        and_order: andOrder,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ โดยใช้ PayId
export async function getByPayId(table, payId, andOrder) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-by-pay-id`,
      {
        table: table,
        pay_id: payId,
        and_order: andOrder,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Tb_Set_Company
export async function getCompany() {
  try {
    const response = await Axios.get(
      `${process.env.REACT_APP_API_URL}/api/get-company`,
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Tb_Set_DocType
export async function getDocType(docCode) {
  try {
    const response = await getData(
      "Tb_Set_DocType",
      `DocType_Status = 'Y'`
    );

    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Tb_Set_TransType
export async function getTransType() {
  try {
    const response = await Axios.get(
      `${process.env.REACT_APP_API_URL}/api/get-trans-type`,
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก Tb_Set_DocStatusColour
export async function getDocStatusColour(docCode, docField) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-doc-status-colour`,
      {
        doc_code: docCode,
        doc_field: docField,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก View_Set_Pr
export async function getViewPrH() {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-pr-h`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก View_Set_Po
export async function getViewPoH() {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-po-h`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลจาก View_Set_AP
export async function getViewAp() {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-ap`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      API_HEADERS
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลลูกค้าจาก API_1001_WHDOC_H ที่ GROUP BY เฉพาะลูกค้า
export async function getCustByType(whDocType, condition) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-cust-by-wh-doc-type`,
      {
        wh_doc_type: whDocType,
        comp_id: window.localStorage.getItem("company"),
        condition: condition,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ดึงข้อมูลลูกค้าจาก API_1001_WHDOC_H ที่ GROUP BY เฉพาะพนักงาน
export async function getEmpByType(wtDocType, condition) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-emp-by-wh-doc-type`,
      {
        wt_doc_type: wtDocType,
        comp_id: window.localStorage.getItem("company"),
        condition: condition,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// Popup แจ้งเตือน ต่างๆ
export function getAlert(status, message, callback) {
  let icon = "";
  let confirmButtonClass = "";
  let cancelButtonClass = "btn btn-danger";

  switch (status) {
    case "OK":
      icon = "success";
      confirmButtonClass = "btn btn-success";
      break;
    case "FAILED":
      icon = "error";
      confirmButtonClass = "btn btn-danger";
      break;
    case "WARNING":
      icon = "warning";
      confirmButtonClass = "btn btn-warning";
      break;
    case "INFO":
      icon = "info";
      confirmButtonClass = "btn btn-info";
      break;
    case "C_DIALOG":
      icon = message === "ยืนยันการลบข้อมูล" ? "question" : "info";
      confirmButtonClass = "btn btn-lg btn-success";
      cancelButtonClass = "btn btn-lg btn-danger";
      console.log("Showing C_DIALOG:", message);
      Swal.fire({
        title: message,
        icon: icon,
        showCancelButton: true,
        buttonsStyling: true,
        customClass: {
          confirmButton: confirmButtonClass,
          cancelButton: cancelButtonClass,
        },
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        willOpen: () => {
          // ตั้งค่า z-index ก่อนที่ Swal จะเปิด
          setTimeout(() => {
            const swalContainer = document.querySelector('.swal2-container');
            if (swalContainer) {
              swalContainer.style.zIndex = '20000';
              swalContainer.classList.add('swal2-container-high-z');
            }
            const swalBackdrop = document.querySelector('.swal2-backdrop-show');
            if (swalBackdrop) {
              swalBackdrop.style.zIndex = '19999';
            }
          }, 0);
        },
        didOpen: (popup) => {
          // ให้ Swal แสดงทับ modal อื่นๆ (z-index สูงกว่า ProductModal ที่ 10500)
          const swalContainer = popup.closest('.swal2-container');
          if (swalContainer) {
            swalContainer.style.zIndex = '20000';
            swalContainer.classList.add('swal2-container-high-z');
          }
          // ตั้งค่า z-index ให้ backdrop ของ Swal สูงกว่า modal ด้วย
          const swalBackdrop = document.querySelector('.swal2-backdrop-show');
          if (swalBackdrop) {
            swalBackdrop.style.zIndex = '19999';
          }
          console.log("Swal dialog opened, z-index set to 20000");
        },
      }).then((result) => {
        console.log("Swal result:", result);
        if (result.isConfirmed) {
          console.log("User confirmed, calling callback(true)");
          if (callback) {
            callback(true);
          }
        } else {
          console.log("User cancelled, calling callback(false)");
          if (callback) {
            callback(false);
          }
        }
      }).catch((error) => {
        console.error("Swal error:", error);
      });
      return;
    default:
      console.error(`Invalid status: ${status}`);
      return;
  }

  // เลื่อนหน้าขึ้นด้านบนสุด
  window.scrollTo(0, 0);

  Swal.fire({
    title: message,
    icon: icon,
    buttonsStyling: false,
    customClass: {
      confirmButton: confirmButtonClass,
    },
    willOpen: () => {
      // ตั้งค่า z-index ก่อนที่ Swal จะเปิด
      setTimeout(() => {
        const swalContainer = document.querySelector('.swal2-container');
        if (swalContainer) {
          swalContainer.style.zIndex = '20000';
          swalContainer.classList.add('swal2-container-high-z');
        }
        const swalBackdrop = document.querySelector('.swal2-backdrop-show');
        if (swalBackdrop) {
          swalBackdrop.style.zIndex = '19999';
        }
      }, 0);
    },
    didOpen: (popup) => {
      // ให้ Swal แสดงทับ modal อื่นๆ (z-index สูงกว่า ItemModal ที่ 1060 และ ProductModal ที่ 10500)
      const swalContainer = popup.closest('.swal2-container');
      if (swalContainer) {
        swalContainer.style.zIndex = '20000';
        swalContainer.classList.add('swal2-container-high-z');
      }
      // ตั้งค่า z-index ให้ backdrop ของ Swal สูงกว่า modal ด้วย
      const swalBackdrop = document.querySelector('.swal2-backdrop-show');
      if (swalBackdrop) {
        swalBackdrop.style.zIndex = '19999';
      }
    },
  });
}

// ฟังก์ชันสำหรับจัดรูปแบบจำนวนเงิน
export function formatCurrency(amount, isItemPriceUnit = false) {
  const decimalPlaces = isItemPriceUnit ? 4 : 2;

  // ถ้า amount เป็น string แล้วให้ return ออกเลย
  if (typeof amount === "string") {
    return amount;
  }

  if (typeof amount !== "number" || isNaN(amount)) {
    return decimalPlaces === 4 ? "0.0000" : "0.00";
  }


  const formattedAmount = amount.toFixed(decimalPlaces);

  return formattedAmount.replace(/\d(?=(\d{3})+\.)/g, "$&,");
}

export function parseCurrency(formattedAmount) {
  // ตรวจสอบว่า formattedAmount เป็น null หรือว่าง
  if (formattedAmount == null || formattedAmount === "") {
    return formattedAmount;
  }

  if (typeof formattedAmount === "number") return formattedAmount;
  if (typeof formattedAmount !== "string") return NaN;

  // ลบช่องว่างและเครื่องหมายพันหลัก ถ้าไปโดนฟังชั่น formatCurrency แปลงค่ามา
  const cleanedAmount = formattedAmount.replace(/,/g, "").trim();

  // แปลงค่ากลับไปเป็นตัวเลขเหมือนเดิม สมมุติ 100,400.00 จะแปลงเป็น 100400 (เคสที่พี่คินแจ้งมา)
  const numericValue = parseFloat(cleanedAmount);

  // ตรวจสอบว่าผลลัพธ์เป็นตัวเลขที่ถูกต้อง (ห้ามโยนกลับไปเป็น String เด็ดขาด ไม่งั้นเราจะชิปหายกันหมด)
  if (isNaN(numericValue)) {
    return formattedAmount;
  }

  // ปรับทศนิยมให้ตรงกับจำนวนที่ต้องการ (4 ตำแหน่ง)
  return Number(numericValue.toFixed(4));
}

// ฟังก์ชั่นเพิ่ม DocNo (For PR, PO)
export function getMaxDocNo(list, title) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return title + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.Doc_No > max ? item.Doc_No : max;
  }, list[0].Doc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return title + currentYear + currentMonth + "0001";
  }

  return incrementDocNo(maxDoc);
}
// ฟังก์ชั่นเพิ่มเสริม DocNo (For PR, PO)
export function incrementDocNo(docNo) {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
}

// ฟังก์ชั่นเพิ่ม RecNo
export function getMaxRecNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `REC${currentYear}${currentMonth}0001`;
  }

  const maxRec = list.reduce((max, item) => {
    return item.Rec_No > max ? item.Rec_No : max;
  }, list[0].Rec_No);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxRec.slice(3, 5) !== currentYear ||
    maxRec.slice(5, 7) !== currentMonth
  ) {
    return `REC${currentYear}${currentMonth}0001`;
  }

  return incrementRecNo(maxRec);
}
// removed unused: getMaxRecNoForTest
// ฟังก์ชั่นเพิ่มเสริม RecNo
export function incrementRecNo(recNo) {
  const prefix = recNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(recNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
}

// ฟังก์ชั่นดึง Max ของ Pay
export function getMaxPayNo(list, givenDate) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  // แปลงวันที่จากรูปแบบ "13-09-2567" เป็นปีและเดือน
  let year, month;
  if (givenDate) {
    const parts = givenDate.split("-");
    const monthStr = parts[1];
    const yearStr = parts[2];
    year = yearStr.slice(-2); // ดึงสองหลักสุดท้ายของปี พ.ศ.
    month = monthStr; // เดือน
  } else {
    year = currentYear;
    month = currentMonth;
  }

  // เช็คว่ามีข้อมูล Pay_No หรือไม่
  if (!list || list.length < 1) {
    return `PAY${year}${month}0001`;
  }

  // หาค่าสูงสุดของ Pay_No
  const maxPay = list.reduce((max, item) => {
    return item.Pay_No > max ? item.Pay_No : max;
  }, list[0].Pay_No);

  // เช็คปีและเดือนใน Pay_No ล่าสุด
  const maxPayYear = maxPay.slice(3, 5);
  const maxPayMonth = maxPay.slice(5, 7);

  if (maxPayYear !== year || maxPayMonth !== month) {
    return `PAY${year}${month}0001`;
  }

  return incrementPayNo(maxPay);
}
// ฟังก์ชั่นเพิ่มเสริม PayNo
export function incrementPayNo(payNo) {
  const prefix = payNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(payNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
}

// ฟังก์ชั่นดึง Max ของ Line
export async function getLineByDocId(table, docId) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-line-by-doc-id`,
      {
        table: table,
        doc_id: docId,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ฟังก์ชั่นเพิ่ม AdjNo
export function getMaxAdjNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `ADJ${currentYear}${currentMonth}0001`;
  }

  const maxAdj = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxAdj.slice(3, 5) !== currentYear ||
    maxAdj.slice(5, 7) !== currentMonth
  ) {
    return `ADJ${currentYear}${currentMonth}0001`;
  }

  return incrementAdjNo(maxAdj);
}
// ฟังก์ชั่นเพิ่มเสริม AdjNo
export function incrementAdjNo(adjNo) {
  const prefix = adjNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(adjNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
}

// ฟังก์ชั่นเพิ่ม TnsNo
export function getMaxTnsNo(list) {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `TNS${currentYear}${currentMonth}0001`;
  }

  const maxTns = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxTns.slice(3, 5) !== currentYear ||
    maxTns.slice(5, 7) !== currentMonth
  ) {
    return `TNS${currentYear}${currentMonth}0001`;
  }

  return incrementTnsNo(maxTns);
}
// ฟังก์ชั่นเพิ่มเสริม TnsNo
export function incrementTnsNo(tnsNo) {
  const prefix = tnsNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(tnsNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
}

// ฟังก์ชั่นเพิ่ม WDPNo
export function getMaxWDPNo(list, prefix) {
  const { currentYear, currentMonth } = getCurrentYearMonth();
  const currentPrefix = `${prefix}${currentYear}${currentMonth}`;

  // กรองเฉพาะรายการที่ prefix ตรง
  const filteredList = list.filter((item) =>
    item.WHDoc_No.startsWith(currentPrefix)
  );

  if (filteredList.length === 0) {
    return `${currentPrefix}0001`;
  }

  const maxDoc = filteredList.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, filteredList[0].WHDoc_No);

  return incrementWDPNo(maxDoc);
}

// ฟังก์ชั่นเพิ่มเสริม WDPNo
function incrementWDPNo(docNo) {
  const prefix = docNo.slice(0, 7);
  const numPart = parseInt(docNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
}

// ฟังก์ชัน randomDelay ใช้สำหรับทดสอบหน่วงเวลาดึงเลข Doc_No เบื้องต้น (ใช้ชั่วคราวไปก่อน)
export function randomDelay() {
  // const delay = Math.floor(Math.random() * 5000); // สุ่มหน่วงเวลา 0-5000 มิลลิวินาที
  // console.debug(`Random delay: ${delay} ms`);
  // return new Promise((resolve) => setTimeout(resolve, delay));
  return new Promise((resolve) =>
    setTimeout(resolve, Math.floor(Math.random() * 5000))
  );
}

export async function getPriceForIce(arCode, itemCode, itemQty) {
  const aItemIce = ['101', '102', '103', '104'];

  let itemPrice = 0.0;
  let nPrice = 0.0;
  let cArSpriceUse = 'N';
  let cItemSpriceUse = 'Y';
  let nArSpriceId = 0;

  // เก็บตัวแปรสำหรับ 3 กระสอบ
  // no local AR ICE promo variable required in frontend calculation

  if (aItemIce.includes(itemCode)) {
    const result = await getDataWithComp('Tb_Set_AR', `AND AR_Code = '${arCode}'`);

    if (result && result.length > 0) {
      const firstRow = result[0];
      nPrice = firstRow?.Default_Price || 0.0;
      cArSpriceUse = firstRow?.AR_SPrice_use || 'N';
      nArSpriceId = firstRow?.AR_SPrice_id || 0;
      // arIcePro is not used in frontend calculation; backend may use it
      // const arIcePro = firstRow?.AR_ICE_Pro || null;
    }
  }

  const itemResult = await getDataWithComp(
    'Tb_Set_Item',
    `AND Item_Code = '${itemCode}'`,
    {
      fields: ["Item_Id", "Item_Code", "Item_Price", "Item_SPrice_use"]
    }
  );

  if (itemResult && itemResult.length > 0) {
    const firstItemRow = itemResult[0];
    cItemSpriceUse = firstItemRow?.Item_SPrice_use || 'Y';
    const nItemId = firstItemRow?.Item_Id || 0;

    if (nPrice === 0.0) {
      itemPrice = firstItemRow?.Item_Price || 0.0;
    } else {
      itemPrice = nPrice;
    }

    let nProQty = 0.0;
    let nProPrice = 0.0;

    if (cArSpriceUse === 'Y' && cItemSpriceUse === 'Y') {
      const sPriceResult = await getDataWithComp(
        'Tb_Set_ItemSPrice',
        `AND sp_id = ${nArSpriceId} AND item_id = ${nItemId}`
      );

      if (sPriceResult && sPriceResult.length > 0) {
        const firstSPriceRow = sPriceResult[0];
        nProQty = firstSPriceRow?.pro_qty || 0.0;
        nProPrice = firstSPriceRow?.pro_price || 0.0;

        if (firstSPriceRow?.itemsp_price > 0.0) {
          itemPrice = firstSPriceRow.itemsp_price;
        }
      }
    }

    if (nProQty <= 0.0) {
      // no promotion quantity -> normal pricing
    } else {
      const n = Math.floor(itemQty / nProQty);
      // calculate promotion-adjusted total if needed (not returned by this function)
      const _promoTotal = n * nProPrice + (itemQty - n * nProQty) * itemPrice;
      void _promoTotal; // explicit no-op to satisfy linters
    }
  }

  return itemPrice;
};

export async function getDiscountForIce(itemList, arId) {
  try {
    const getArById = await getDataWithComp('Tb_Set_AR', `AND AR_Id = ${arId}`);
    if (getArById && getArById.length > 0) {
      if (getArById[0].AR_ICE_Pro) {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/sp_get_pro_discount`,
          {
            comp_id: localStorage.getItem('company'),
            pro_code: getArById[0].AR_ICE_Pro,
            item_1: itemList[0]?.itemCode || "101",
            qty_1: parseCurrency(itemList[0]?.itemQty) || 0,
            price_1: itemList[0]?.itemPriceUnit || 0,
            item_2: itemList[1]?.itemCode || "102",
            qty_2: parseCurrency(itemList[1]?.itemQty) || 0,
            price_2: itemList[1]?.itemPriceUnit || itemList[0]?.itemPriceUnit,
            item_3: itemList[2]?.itemCode || "103",
            qty_3: parseCurrency(itemList[2]?.itemQty) || 0,
            price_3: itemList[2]?.itemPriceUnit || itemList[0]?.itemPriceUnit,
            item_4: itemList[3]?.itemCode || "104",
            qty_4: parseCurrency(itemList[3]?.itemQty) || 0,
            price_4: itemList[3]?.itemPriceUnit || itemList[0]?.itemPriceUnit,
          },
          {
            headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
          }
        );
        return response.data[0].Total_discount;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  } catch (error) {
    console.debug("Error fetching data:", error);
    return 0;
  }
};

// Update Status ในข้อมูล
export async function updateStatusByNo(table, field, status, where) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/update-status`,
      {
        table: table,
        field: field,
        status: status,
        where: where,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// Update Qty ในข้อมูล
export async function updateQty(table, updateCode, where) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/update-qty`,
      {
        table: table,
        update_code: updateCode,
        where: where,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// Insert ข้อมูลด้วย Table, Field, Values
export async function insertData(table, field, values) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/create-data`,
      {
        table: table,
        field: field,
        values: values,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    return { status: "FAILED", message: error?.response?.data?.message || error.message || "Server error" };
  }
}

// Update ข้อมูลด้วย Table, Values, Where
export async function updateData(table, values, where) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/update-data`,
      {
        table: table,
        values: values,
        where: where,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updateData:", error);
    return { status: "FAILED", message: error?.response?.data?.message || error.message || "Server error" };
  }
}

// Delete ข้อมูลด้วย Table, Where
export async function deleteData(table, where) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/delete`,
      {
        table: table,
        where: where,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleteData:", error);
    return { status: "FAILED", message: error?.response?.data?.message || error.message || "Server error" };
  }
}

// ฟังชั่นการสร้าง Tb_Set_Rec_No ใช้ชั่วคราว (จากพี่แบงค์)
export async function createSetRecNo(recNo) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/create-tb-set-rec-no`,
      {
        rec_no: recNo,
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ฟังชั่นการเรียกใช้ SP_RUN_NUMBER ของ Store Procedure (ของพี่สมบัติ)
export async function getSpRunNumber(prefix) {
  try {
    const { currentYear, currentMonth } = getCurrentYearMonth();

    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/sp_run_number`,
      {
        comp_id: localStorage.getItem("company"),
        yearmonth: `${currentYear}${currentMonth}`,
        prefix: prefix,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data.run_number;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

// ฟังชั่นกด ESC แล้วปิด Modal (ลองทดสอบดูก่อน)
export function useEscapeClose(isOpen, onClose) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);
}

// ฟังชั่นการเคลียร์ localStorage ของหน้ารายการ (เคสพี่คิน)
export async function getClearLocalStorage() {
  try {
    localStorage.removeItem("searchTerm");
    localStorage.removeItem("selectedRow");
    localStorage.removeItem("sortColumn");
    localStorage.removeItem("sortOrder");
    localStorage.removeItem("startDate");
    localStorage.removeItem("endDate");
    localStorage.removeItem("itemsPerPageDropdown");
    localStorage.removeItem("currentPage");
  } catch (error) {
    console.error("error:", error);
  }
}

export async function uploadSlip(base64Image, docId, docCodeId) {
  try {
    const payHistory = await getDataWithComp(
      "Pay_History",
      `AND DocCode_Id = ${docCodeId} AND Doc_Id = ${docId} AND Pay_Type = 2`
    );
    await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/upload-file-slip`,
      {
        comp_id: localStorage.getItem("company"),
        doc_id: docId,
        doccode_id: docCodeId,
        upload_by: localStorage.getItem("emp_name"),
        file_status: "Y",
        files: base64Image,
        doc_no_ref: payHistory[0].Pay_His_Id,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );
  } catch (error) {
    console.error("error:", error);
  }
}

export async function fetchServiceDetails(serviceId) {
  if (!serviceId) {
    return { status: "FAILED", details: [] };
  }

  try {
    const response = await Axios.get(
      `${process.env.REACT_APP_API_URL}/api/services/${serviceId}/details`,
      API_HEADERS
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching service details:", error);
    const message =
      error?.response?.data?.message || error.message || "Fetch failed";
    throw new Error(message);
  }
}

export async function createServiceDetail(serviceId, payload) {
  if (!serviceId || !payload) {
    throw new Error("Invalid detail payload");
  }

  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/services/${serviceId}/details`,
      payload,
      API_HEADERS
    );
    return response.data;
  } catch (error) {
    console.error("Error creating service detail:", error);
    const message =
      error?.response?.data?.message || error.message || "Create failed";
    throw new Error(message);
  }
}

export async function updateServiceDetail(detailId, payload) {
  if (!detailId || !payload) {
    throw new Error("Invalid detail payload");
  }

  try {
    const response = await Axios.put(
      `${process.env.REACT_APP_API_URL}/api/services/details/${detailId}`,
      payload,
      API_HEADERS
    );
    return response.data;
  } catch (error) {
    console.error("Error updating service detail:", error);
    const message =
      error?.response?.data?.message || error.message || "Update failed";
    throw new Error(message);
  }
}

export async function deleteServiceDetail(detailId) {
  if (!detailId) {
    throw new Error("Invalid detail id");
  }

  try {
    const response = await Axios.delete(
      `${process.env.REACT_APP_API_URL}/api/services/details/${detailId}`,
      API_HEADERS
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting service detail:", error);
    const message =
      error?.response?.data?.message || error.message || "Delete failed";
    throw new Error(message);
  }
}

export async function uploadServiceDetailImages(detailId, images) {
  if (!detailId || !Array.isArray(images) || images.length === 0) {
    throw new Error("Invalid image payload");
  }

  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/services/details/${detailId}/images`,
      { images },
      API_HEADERS
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading service detail images:", error);
    const message =
      error?.response?.data?.message || error.message || "Upload failed";
    throw new Error(message);
  }
}

export async function deleteServiceDetailImage(imageId) {
  if (!imageId) {
    throw new Error("Invalid image id");
  }

  try {
    const response = await Axios.delete(
      `${process.env.REACT_APP_API_URL}/api/services/details/images/${imageId}`,
      API_HEADERS
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting service detail image:", error);
    const message =
      error?.response?.data?.message || error.message || "Delete failed";
    throw new Error(message);
  }
}

export async function uploadMultipleSlips(slipFiles, docId, docCodeId) {
  try {
    // Validate input
    if (!slipFiles || slipFiles.length === 0) {
      throw new Error("No files provided for upload");
    }

    if (slipFiles.length > 100) {
      throw new Error("Maximum 100 files allowed");
    }

    // Get payment history data
    const payHistory = await getDataWithComp(
      "Pay_History",
      `AND DocCode_Id = ${docCodeId} AND Doc_Id = ${docId} AND Pay_Type = 2`
    );

    if (!payHistory || payHistory.length === 0) {
      throw new Error("Payment history not found");
    }

    // Prepare the request payload
    const payload = {
      comp_id: localStorage.getItem("company"),
      doc_id: docId,
      doccode_id: docCodeId,
      upload_by: localStorage.getItem("emp_name"),
      file_status: "Y",
      doc_no_ref: payHistory[0].Pay_His_Id,
    };

    // กรองไฟล์ที่ไม่ใช่ null/undefined และแปลงเป็น array
    const validFiles = slipFiles.filter((file) => file != null);

    if (validFiles.length === 0) {
      throw new Error("No valid files found for upload");
    }

    // ส่งไฟล์เป็น array ตาม API format ใหม่
    payload.files = validFiles;

    // เรียก API /upload-files-slip
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/upload-files-slip`,
      payload,
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error uploading multiple slips:", error);
    throw error;
  }
}

export async function getMultipleSlips(docId, docCodeId) {
  try {
    const files = await getData(
      "Upload_File_List",
      `DocCode_Id = ${docCodeId} AND Doc_ID = ${docId} ORDER BY Upload_Date ASC`
    );

    if (!files || files.length === 0) {
      return [];
    }

    return files.map((file, index) => {
      return {
        id: file.F_Id, // ✅ ใช้ F_Id เป็น primary key
        fileName: file.File_Name,
        fileUrl: file.File_Url,
        uploadDate: file.Upload_Date,
        uploadBy: file.Upload_By,
      };
    });
  } catch (error) {
    console.error("Error getting multiple slips:", error);
    throw error;
  }
}

export async function deleteSingleSlip(fileId) {
  try {
    console.log("🗑️ Deleting file F_Id:", fileId);

    // ✅ ใช้ F_Id แทน ID
    await deleteData("Upload_File_List", `WHERE F_Id = ${fileId}`);

    console.log("✅ Delete completed");
    return { status: "OK", message: "ลบไฟล์สำเร็จ" };
  } catch (error) {
    console.error("❌ Error deleting single slip:", error);
    throw error;
  }
}

export async function uploadArImage(base64Images, arId) {
  try {
    // ตรวจสอบว่า base64Images เป็น array หรือ string เดี่ยว
    let files;
    if (Array.isArray(base64Images)) {
      files = base64Images; // หลายไฟล์
    } else {
      files = base64Images; // ไฟล์เดี่ยว
    }

    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/upload-ar-image`,
      {
        comp_id: localStorage.getItem("company"),
        ar_id: arId,
        upload_by: localStorage.getItem("emp_id"),
        files: files,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error uploading AR image:", error);
    throw error;
  }
}

export async function DeleteArImage(url) {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/deleteArImage`,
      {
        image_url: url,
      },
      {
        headers: { key: "THUNDER1WoV5UbrGPq5iOXS2SS4ODR9999" },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting AR image:", error);
    throw error;
  }
}
